import React from 'react';
import { getRouteApi } from '@tanstack/react-router';

import AccountProfileEdit from '../../Account/ProfileEdit';

const DashboardAdminUserEdit: React.FC = () => {
  const routeApi = getRouteApi('/dashboard/admin/users/$userId');
  const { user } = routeApi.useLoaderData()

  return (
    <>
      <div className="dashboard-header page-header">
        <h2 className="page-title">Edit <em>user</em></h2>
          <p>Edit user details</p>
      </div>
      <div className="dashboard-admin dashboard-admin-user account-container wa-stack wa-gap-0 inner">
        <AccountProfileEdit profile={user} />
      </div>
    </>
  );
}

export default DashboardAdminUserEdit;
